export const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', "Jum'at", 'Sabtu']

export const locationTypes = {
  WAREHOUSE: 'WAREHOUSE',
  HUB: 'HUB',
  ASTRO_OFFLINE: 'ASTRO OFFLINE',
  MEGAHUB: 'MEGAHUB',
  MEGAHUB_2_0: 'MEGAHUB 2.0',
  OFFICE: 'OFFICE',
  VIRTUAL: 'VIRTUAL',
  VENDING_MECHINE: 'VENDING MECHINE',
  DIGITAL_GOODS: 'DIGITAL GOODS',
} as const
